import React from 'react';
import PropTypes from 'prop-types';

import ProductDescription from 'components/productdetail/description/ProductDescription';
import styles from 'styles/components/productdetail/expandableProductDescription.scss';
import marketplace from 'cfg/marketplace.json';
const {
  links: {
    glossaryLink
  },
  pdp: {
    productDescriptionTitle,
    showDescriptionSizeChart,
    showDescriptionGlossary,
    showDescriptionReportError
  }
} = marketplace;

const numberOfItemsToShowWhenCollapsed = 5;

const ExpandableProductDescription = ({ descriptionItems, productId, colorId, defaultProductType, isExpanded, allowCollapse, onReportError, onToggle, brandLogo }, { testId = () => null }) => {
  let toggleButton;

  // Don't show expand collapse if there are less items then numberOfItemsToShowWhenCollapsed
  if (allowCollapse && descriptionItems && descriptionItems.bulletPoints.length > numberOfItemsToShowWhenCollapsed) {
    toggleButton = (
      <button type="button" className={styles.descriptionToggleButton} onClick={onToggle}>
        {isExpanded ? (
          <span
            data-track-action="Product-Page"
            data-track-label="Information"
            data-track-value="Show-less"
            data-test-id={testId('productDescriptionExpander')}>
            Show Less Information
          </span>
        ) : (
          <span
            data-track-action="Product-Page"
            data-track-label="Information"
            data-track-value="Show-More"
            data-test-id={testId('productDescriptionExpander')}>
            Show More Information
          </span>
        )}
      </button>
    );
  }

  // If the bullet points are less than five, then pass isExpanded as true
  if (descriptionItems && descriptionItems.bulletPoints.length <= 5) {
    isExpanded = true;
  }

  return (
    <div>
      <ProductDescription
        productTitle={productDescriptionTitle}
        descriptionItems={descriptionItems}
        productId={productId}
        colorId={colorId}
        defaultProductType={defaultProductType}
        glossaryLink={glossaryLink}
        isExpanded={isExpanded}
        allowCollapse={allowCollapse}
        onReportError={onReportError}
        showSizeCharts={showDescriptionSizeChart}
        showGlossary={showDescriptionGlossary}
        showReportError={showDescriptionReportError}
        brandLogo={brandLogo}/>
      {toggleButton}
    </div>
  );
};

ExpandableProductDescription.defaultProps = {
  isExpanded: false
};

ExpandableProductDescription.propTypes = {
  descriptionItems: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]).isRequired,
  productId: PropTypes.string.isRequired,
  colorId: PropTypes.string,
  defaultProductType: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  allowCollapse: PropTypes.bool,
  onReportError: PropTypes.func.isRequired
};

ExpandableProductDescription.contextTypes = {
  testId: PropTypes.func
};

export default ExpandableProductDescription;
